// Fossor.Co theme JS — cart drawer + product gallery + variant selector

(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Cart drawer
  const drawer = $('#CartDrawer');
  const backdrop = $('#CartBackdrop');
  const openBtns = $$('[data-cart-open]');
  const closeBtns = $$('[data-cart-close]');
  const cartCount = $('[data-cart-count]');

  function openDrawer() {
    drawer?.classList.add('is-open');
    backdrop?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeDrawer() {
    drawer?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openBtns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  closeBtns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); closeDrawer(); }));
  backdrop?.addEventListener('click', closeDrawer);

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  function money(cents, currency) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency || window.Shopify?.currency?.active || 'USD' });
  }

  function renderCart(cart) {
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }
    const body = $('#CartDrawerBody');
    const foot = $('#CartDrawerFoot');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="muted" style="text-align:center;padding:2rem 0;">Your bag is empty.</p>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = 'block';
    body.innerHTML = cart.items.map(item => `
      <div class="line-item" data-key="${item.key}">
        <div class="line-item__img">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
        <div>
          <p class="line-item__title">${item.product_title}</p>
          <div class="line-item__variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="line-item__price">${money(item.final_line_price, cart.currency)}</div>
          <div style="margin-top:.5rem;display:flex;gap:.75rem;align-items:center;">
            <div class="line-item__qty">
              <button data-qty-dec>−</button>
              <input type="text" value="${item.quantity}" data-qty-input readonly>
              <button data-qty-inc>+</button>
            </div>
            <button class="line-item__remove" data-remove>Remove</button>
          </div>
        </div>
      </div>
    `).join('');
    $('#CartTotal').textContent = money(cart.total_price, cart.currency);

    body.querySelectorAll('.line-item').forEach(el => {
      const key = el.getAttribute('data-key');
      const input = el.querySelector('[data-qty-input]');
      el.querySelector('[data-qty-inc]').addEventListener('click', () => changeQty(key, parseInt(input.value, 10) + 1));
      el.querySelector('[data-qty-dec]').addEventListener('click', () => changeQty(key, Math.max(0, parseInt(input.value, 10) - 1)));
      el.querySelector('[data-remove]').addEventListener('click', () => changeQty(key, 0));
    });
  }

  async function changeQty(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  // Product forms — add to cart via AJAX
  $$('form[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn?.textContent;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!res.ok) throw new Error('Add to cart failed');
        openDrawer();
      } catch (err) {
        alert('Could not add to bag. Please try again.');
        console.error(err);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }
    });
  });

  // Variant selector on product page
  const variantData = window.__variants;
  if (variantData) {
    const form = $('form[data-product-form]');
    const idInput = form?.querySelector('input[name="id"]');
    const priceEl = $('[data-product-price]');
    const addBtn = form?.querySelector('[type="submit"]');
    const selected = {};

    $$('[data-option]').forEach(btn => {
      btn.addEventListener('click', () => {
        const name = btn.getAttribute('data-option');
        const value = btn.getAttribute('data-value');
        selected[name] = value;
        // toggle active state within group
        $$(`[data-option="${name}"]`).forEach(b => b.classList.toggle('is-active', b === btn));
        // find variant
        const match = variantData.find(v => v.options.every((opt, i) => opt === selected[variantData[0].option_names[i]]));
        if (match) {
          idInput.value = match.id;
          if (priceEl) priceEl.textContent = match.price;
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
          }
        }
      });
    });
  }

  // Product gallery
  $$('.product__thumb').forEach(t => {
    t.addEventListener('click', () => {
      const src = t.getAttribute('data-full');
      const img = $('.product__main-image img');
      if (img && src) img.src = src;
      $$('.product__thumb').forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
    });
  });

  // Initial cart count on load
  fetchCart();
})();
